export default "__VITE_ASSET__NNIgSxeY__"